export default __webpack_public_path__ + "static/media/ndqn1.410098f0.png";